
import { Button } from "@/components/ui/button";
import { ToggleLeft, ToggleRight, Trash2 } from "lucide-react";

interface User {
  id: number;
  username: string;
  credits: number;
  active: boolean;
}

interface UserTableProps {
  users: User[];
  onSelectUser: (userId: number) => void;
  onToggleStatus: (userId: number) => void;
  onDeleteUser: (userId: number) => void;
}

export function UserTable({ users, onSelectUser, onToggleStatus, onDeleteUser }: UserTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b">
            <th className="py-2 px-4 text-left">ID</th>
            <th className="py-2 px-4 text-left">Username</th>
            <th className="py-2 px-4 text-left">Credits</th>
            <th className="py-2 px-4 text-left">Κατάσταση</th>
            <th className="py-2 px-4 text-left">Ενέργειες</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id} className="border-b">
              <td className="py-2 px-4">{user.id}</td>
              <td className="py-2 px-4">{user.username}</td>
              <td className="py-2 px-4">{user.credits}</td>
              <td className="py-2 px-4">
                <span className={`px-2 py-1 rounded-full text-xs ${user.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                  {user.active ? 'Ενεργός' : 'Ανενεργός'}
                </span>
              </td>
              <td className="py-2 px-4">
                <div className="flex space-x-2">
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => onSelectUser(user.id)}
                  >
                    Επιλογή
                  </Button>
                  <Button 
                    variant={user.active ? "destructive" : "default"}
                    size="sm"
                    onClick={() => onToggleStatus(user.id)}
                  >
                    {user.active ? (
                      <><ToggleRight className="h-4 w-4 mr-1" /> Απενεργοποίηση</>
                    ) : (
                      <><ToggleLeft className="h-4 w-4 mr-1" /> Ενεργοποίηση</>
                    )}
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => onDeleteUser(user.id)}
                  >
                    <Trash2 className="h-4 w-4 mr-1" /> Διαγραφή
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
